import { MouseEvent } from 'react';
import cn from 'classnames';
import Icon from '@components/Icon/Icon';
import { FCX, Portal, Tooltip, useUuid } from "@datassential/platform-ui-lib";

type ActionIconProps = {
    isDisabled?: boolean;
    tooltip?: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

const ActionIcon: FCX<ActionIconProps> = ({
    isDisabled = false,
    tooltip = '',
    children,
    onClick,
    className,
}) => {
    const id = useUuid();
    return (
        <div
            className={cn(
                'ActionIcon',
                !isDisabled && 'is-active',
                className,
            )}
            onClick={onClick}
            data-tooltip-id={id}
        >
            <Icon type="small">{children}</Icon>
            {!!tooltip && (
                <Portal>
                    <Tooltip
                        id={id}
                        place="top"
                        style={{
                            background: 'transparent',
                            padding: 0,
                        }}
                        noArrow
                    >
                        <div className="ActionIcon__tooltip">{tooltip}</div>
                    </Tooltip>
                </Portal>
            )}
        </div>
    );
};

export default ActionIcon;
